interface PrimaryDetailsProps {
  headerText: string;
  subText: string;
}

const PrimaryDetails = (props: { details?: PrimaryDetailsProps[] | null }) => {
  return (
    <div className="primary-details--container">
      {props?.details?.map((detail, index) => (
        <div key={index} className="primary-details--singleDetail">
          <div className="primary-details--singleDetail--header">
            {detail.headerText}
          </div>
          <div className="primary-details--singleDetail--text">
            {detail.subText}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PrimaryDetails;
